import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Forces the window to scroll back to the top whenever the route path changes.
 * Mount this once inside <BrowserRouter> so it runs on every navigation.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Drop focus from any element that was clicked on the previous page so
    // we don't carry a focus ring onto a tile in the next route.
    if (document.activeElement && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search]);
  return null;
}
